module.exports = __webpack_public_path__ + "static/media/Extra Volunteer.01131059.png";